import React, { ButtonHTMLAttributes, ReactNode } from "react";
import { Spinner } from "./Spinner.tsx";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "submit" | "danger" | "neutral" | "primary";
  loading?: boolean;
  children: ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  variant = "submit",
  loading = false,
  children,
  className = "",
  disabled,
  ...props
}) => {
  const baseStyles =
    "px-4 py-2 rounded font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2";

  const variantStyles = {
    submit:
      "bg-secondary text-white hover:enabled:bg-secondary-dark focus:ring-secondary",
    danger: "bg-danger text-white hover:enabled:bg-red-700 focus:ring-danger",
    neutral:
      "bg-gray-100 text-gray-800 hover:enabled:bg-gray-200 focus:ring-gray-400",
    primary:
      "bg-primary text-white hover:enabled:bg-primary-dark focus:ring-primary",
  };

  const loadingStyles = loading ? "opacity-70 cursor-wait" : "";

  return (
    <button
      id={`button-${variant}`}
      className={`${baseStyles} ${variantStyles[variant]} ${loadingStyles} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <Spinner size="sm" />}
      {children}
    </button>
  );
};

export { Button };
